{
  "title": "Event-skabelon",
  "description": "Definer indholdet for en genanvendelig event-skabelon",
  "pages": [
    {
      "name": "page_meta",
      "title": "Skabelon",
      "description": "Navn og beskrivelse for skabelonen",
      "elements": [
        {
          "type": "text",
          "name": "template_name",
          "title": "Skabelonnavn",
          "description": "F.eks. \"Førstehjælp\"",
          "isRequired": true
        },
        {
          "type": "comment",
          "name": "template_description",
          "title": "Skabelonbeskrivelse",
          "description": "Kort beskrivelse af hvad skabelonen bruges til"
        }
      ]
    },
    {
      "name": "page1",
      "title": "Side 1",
      "description": "Generelle oplysninger",
      "elements": [
        {
          "type": "dropdown",
          "name": "event_type",
          "title": "Type",
          "isRequired": true,
          "choices": [
            { "value": "exercise", "text": "Øvelse" },
            { "value": "course", "text": "Kursus" },
            { "value": "education", "text": "Uddannelse" }
          ]
        },
        {
          "type": "radiogroup",
          "name": "event_duration_type",
          "visible": false,
          "defaultValue": "single_day",
          "choices": [{ "value": "single_day", "text": "Enkelt dag" }]
        },
        {
          "type": "text",
          "name": "start_date",
          "title": "Standard starttid (reference ved kopiering)",
          "description": "Tidspunktet bruges som udgangspunkt når events kopieres",
          "isRequired": true,
          "inputType": "datetime-local",
          "defaultDateTime": "12:00"
        },
        {
          "type": "text",
          "name": "end_time",
          "startWithNewLine": false,
          "title": "Standard sluttidspunkt",
          "isRequired": true,
          "inputType": "time",
          "defaultValue": "13:00"
        },
        {
          "type": "dropdown",
          "name": "visibility",
          "title": "Tilgængelighed for kopierede events",
          "description": "Hvem må se events oprettet fra denne skabelon?",
          "defaultValue": "private",
          "isRequired": true,
          "choices": [
            { "value": "private", "text": "Privat - i organisation" },
            { "value": "public", "text": "Alle - i DUNA" },
            { "value": "shared", "text": "Delt - med samarbejdsorganisationer" }
          ]
        },
        {
          "type": "dropdown",
          "name": "location",
          "title": "Standard lokation",
          "description": "Kan overskrives ved kopiering til specifikke datoer",
          "isRequired": true,
          "dataSource": "locations",
          "dataSourceKeyField": "locations_name",
          "dataSourceValueField": "guid",
          "mergeWithStaticChoices": true,
          "onChangeUpdateQuestion": "room",
          "choices": [{ "value": "manual", "text": "Manuel" }]
        },
        {
          "type": "dropdown",
          "name": "room",
          "visibleIf": "{location} <> 'manual' and {location} notempty",
          "title": "Standard lokale",
          "requiredIf": "{manual_room_capacity} empty",
          "dataSource": "locations_rooms",
          "dataSourceKeyField": "room_name",
          "dataSourceValueField": "guid"
        },
        {
          "type": "text",
          "name": "manual_location",
          "visibleIf": "{location} = 'manual'",
          "title": "Manuel lokation - Navn",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "manual_location_address",
          "visibleIf": "{location} = 'manual'",
          "title": "Manuel lokation - Adresse",
          "isRequired": true
        },
        {
          "type": "text",
          "name": "manual_room_capacity",
          "visibleIf": "{location} notempty",
          "title": "Manuel lokale - Antal",
          "requiredIf": "{room} empty",
          "inputType": "number"
        },
        {
          "type": "text",
          "name": "short_description",
          "title": "Kort beskrivelse",
          "description": "Til visning i kalender som titel",
          "isRequired": true
        },
        {
          "type": "comment",
          "name": "description",
          "title": "Beskrivelse",
          "isRequired": true
        },
        {
          "type": "dropdown",
          "name": "catering",
          "title": "Forplejning",
          "isRequired": true,
          "choices": [
            { "value": "selv", "text": "Står selv for" },
            { "value": "lokation", "text": "Står eventlokation for" },
            { "value": "irrelevant", "text": "Irrelevant" }
          ]
        }
      ]
    },
    {
      "name": "page2",
      "title": "Side 2",
      "description": "Brug de samme som i ønskede uddannelsesveje / kompetencer",
      "elements": [
        {
          "type": "dualpanel",
          "name": "event_modules",
          "title": "Moduler",
          "dataSource": "dual_panel_modules"
        },
        {
          "type": "dualpanel",
          "name": "event_subtypes",
          "title": "Subtypes / Indholdstemaer",
          "dataSource": "dual_panel_subtypes"
        },
        {
          "type": "dropdown",
          "name": "destination_period",
          "title": "Destinationsperiode",
          "description": "Skift hvis dette event skal fungere som kompetenceafklaring",
          "defaultValue": "current_period",
          "choices": [
            { "value": "current_period", "text": "Nuværende periode" },
            { "value": "last_period", "text": "Sidste periode" },
            { "value": "both_periods", "text": "Begge perioder" }
          ]
        }
      ]
    },
    {
      "name": "page3",
      "title": "Side 3",
      "description": "Ekstra indstillinger",
      "elements": [
        {
          "type": "dropdown",
          "name": "event_active",
          "title": "Aktiv",
          "defaultValue": "active",
          "choices": [
            { "value": "active", "text": "Aktiv" },
            { "value": "inactive", "text": "Inaktiv" }
          ],
          "allowClear": false
        },
        {
          "type": "dropdown",
          "name": "is_shown",
          "title": "Synlighed",
          "defaultValue": "shown",
          "choices": [
            { "value": "shown", "text": "Synlig" },
            { "value": "hidden", "text": "Skjult" }
          ],
          "allowClear": false
        },
        {
          "type": "radiogroup",
          "name": "waitlist",
          "title": "Venteliste",
          "defaultValue": "room_size",
          "choices": [
            { "value": "room_size", "text": "Benyt lokalets størrelse" },
            { "value": "everyone_on_wait_list", "text": "Alle på venteliste standard" },
            { "value": "no_wait_list", "text": "Deaktiver venteliste" }
          ]
        },
        {
          "type": "panel",
          "name": "course_price_panel",
          "visibleIf": "{event_type} = 'course'",
          "title": "Pris",
          "elements": [
            {
              "type": "radiogroup",
              "name": "course_price_type",
              "title": "Kursustype",
              "isRequired": true,
              "choices": [
                { "value": "internal", "text": "Internt kursus" },
                { "value": "revenue_generating", "text": "Indtægtsgivende" }
              ]
            },
            {
              "type": "radiogroup",
              "name": "course_revenue_model",
              "visibleIf": "{course_price_type} = 'revenue_generating'",
              "title": "Indtægtstype",
              "requiredIf": "{course_price_type} = 'revenue_generating'",
              "choices": [
                { "value": "fixed_course", "text": "Fastsat beløb for kursus" },
                { "value": "per_participant", "text": "Per deltagelse per bruger" }
              ]
            },
            {
              "type": "dropdown",
              "name": "customer_guid",
              "visibleIf": "{course_price_type} = 'revenue_generating'",
              "title": "Kunde",
              "dataSource": "customers",
              "dataSourceKeyField": "name",
              "dataSourceValueField": "guid",
              "allowClear": true
            },
            {
              "type": "text",
              "name": "event_price",
              "visibleIf": "{course_price_type} = 'revenue_generating'",
              "title": "Indtægt (kr.)",
              "requiredIf": "{course_price_type} = 'revenue_generating'",
              "defaultValue": 0,
              "inputType": "number",
              "min": 0
            },
            {
              "type": "radiogroup",
              "name": "course_extra_amount_enabled",
              "visibleIf": "{course_price_type} = 'revenue_generating'",
              "title": "Tilføj ekstra beløb",
              "defaultValue": "false",
              "choices": [
                { "value": "false", "text": "Nej" },
                { "value": "true", "text": "Ja" }
              ]
            },
            {
              "type": "text",
              "name": "course_extra_amount",
              "visibleIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
              "title": "Ekstra beløb (kr.)",
              "requiredIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
              "defaultValue": 0,
              "inputType": "number",
              "min": 0
            },
            {
              "type": "comment",
              "name": "course_extra_amount_comment",
              "visibleIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'",
              "title": "Kommentar til ekstra beløb",
              "requiredIf": "{course_price_type} = 'revenue_generating' and {course_extra_amount_enabled} = 'true'"
            }
          ]
        }
      ]
    }
  ],
  "navigationButtonsLocation": "topBottom",
  "showTitle": false,
  "showCompletePage": false,
  "checkErrorsMode": "onValueChanged",
  "dataSource": "event_form_data",
  "showEmptyFormSubmit": false
}
